module.exports = __webpack_public_path__ + "static/media/house-wrap@2x.dad399c2.jpg";